import { render, staticRenderFns } from "./OrganisationInfra.vue?vue&type=template&id=3ce10e12&scoped=true&"
import script from "./OrganisationInfra.vue?vue&type=script&lang=js&"
export * from "./OrganisationInfra.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationInfra.vue?vue&type=style&index=0&id=3ce10e12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce10e12",
  null
  
)

export default component.exports